/**
 * Arco Design 主题配置
 * 替代原有的 MUI theme 系统
 */

// 辅助函数：把 px 转成 rem（用于生成全局 CSS Variables）
export function pxToRem(value) {
    return `${value / 16}rem`;
}

// 字体配置（与原配置保持一致）
const primaryFont = '"Source Han Sans CN", "PingFang SC", "Microsoft YaHei", sans-serif';
const secondaryFont = '"Source Han Sans CN", "PingFang SC", "Microsoft YaHei", sans-serif';

// Arco Design 主题 Token 配置
export const arcoTheme = {
    // 字体配置
    fontFamily: primaryFont,
    fontFamilySecondary: secondaryFont,
    
    // // 字号配置（Arco 使用的是 px 值）
    // // 目前项目只在 ConfigProvider token 和全局 html/body 使用 body1，其他字号如需统一管理可再加回来。
    // fontSize: {
    //     body1: 14,
    // },
    
    // // 字重配置
    // fontWeight: {
    //     regular: 400,
    //     medium: 500,
    //     semiBold: 600,
    //     bold: 700,
    // },
    
    // // 行高配置
    // lineHeight: {
    //     h1: 36 / 28,
    //     h2: 32 / 22,
    //     h3: 28 / 18,
    //     h4: 24 / 16,
    //     h5: 22 / 14,
    //     h6: 20 / 12,
    //     body1: 22 / 14,
    //     body2: 20 / 12,
    // },
};

// 导出 CSS 变量形式（用于全局样式）
export const typographyVariables = `
:root {
    /* 字体家族 */
    --font-family-primary: ${primaryFont};
    --font-family-secondary: ${secondaryFont};
    
    /* 字号（目前只用到 body1） */
    --font-size-body1: ${pxToRem(14)};
    
    /* 字重 */
    // --font-weight-regular: 400;
    // --font-weight-medium: 500;
    // --font-weight-semibold: 600;
    // --font-weight-bold: 700;
    
    /* 行高（目前只用到 body） */
    // --line-height-body: 1.5;
}
`;
